<ng-container *ngIf="signOnly; else fullContent">
  <!-- Sign Only Mode -->
  <div class="w100">
        <!-- =============== Exam Signature (Start) =============== -->
        <div class="w100 l-flex-w t-boxMargin--spacebyPadding summary" style="justify-content: center;">
        <div class="w50 sign-exam-col">
            <section class="m-box">
                <h2>
                    Sign Exam
                </h2>
                <div class="l-flex-c l-flex-w indicative-fieldset">
                    <button class="save_patieont"
                        *ngIf="ls.userType === 'doctor' && !showPrintOpts && !signatureService.isExamSigned(es.examObject)"
                        (click)="showPrintOpts = true">
                        Sign Exam as {{ls.getUserName()}}
                    </button>
                
                    <span *ngIf="signatureService.isExamSigned(es.examObject)">
                        Signed on {{es.examObject.SignedDate | date:'d-M-y H:mm:ss'}} by {{es.examObject.SignedBy}}
                    </span>
                </div>
            </section>
        </div>
        </div>
        <!-- =============== Exam Signature (End) =============== -->
  </div>
  <app-printopts *ngIf="showPrintOpts" (closed)="closePreview($event)" [showopts]="false" [signature]="true"></app-printopts>
</ng-container>

<ng-template #fullContent>
  <!-- Full Content Mode -->
<div [formGroup]="gastroService.gastroForm">
    <div>
    <!-- <div *ngIf="pathologyError" class="print-history-popup">
        <div class="print-history-popup-body">
            <h2 class="popup-title">{{!gastroService.gastroForm.get('Reasone').value ? 'Exam Indication cannot be empty' : 'No samples have been taken for this exam'}} </h2>
            <button (click)="pathologyError=false" class="print-history-popup-close" aria-label="close popup"></button>
        </div>
    </div> -->
    <!-- HMO Section -->
    <div class="h100 l-flex-w t-boxMargin--spacebyPadding " >
     
      <div class="w50" *ngIf="es.AWLID">
        <section class="m-box" style="height: 100%;" [formGroup]="gastroService.awlForm">
          <h2>HMO</h2>
          <div class="l-flex-c l-flex-w indicative-fieldset ">
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Leumit" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>Leumit</span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Clalit" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>Clalit</span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Macabi" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>Macabi</span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Meuhedet" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>Meuhedet</span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Private" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>Private</span>
            </label>
            <br>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="הפניקס" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>הפניקס</span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="כלל" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>כלל</span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="איילון" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>איילון</span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="הכשרה ביטוח" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span>הכשרה ביטוח</span>
            </label>
          </div>
          <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 1em;">
            <div class="w100" style="margin-bottom: 1em;" *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi' || gastroService.awlForm.get('HMO').value == 'Leumit' || gastroService.awlForm.get('HMO').value == 'Meuhedet' || gastroService.awlForm.get('HMO').value == 'Clalit'">
              <div class="l-flex l-flex-c t-field t-field-pad input">
                <label matTooltip="מס. התחייבות" *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi' || gastroService.awlForm.get('HMO').value == 'Leumit' || gastroService.awlForm.get('HMO').value == 'Meuhedet'">
                  מספר התחייבות
                </label>
                <label matTooltip="מס. הפניה" *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit'">
                  קוד הזמנה/הפניה
                </label>
                <i class="t-sep"></i>
                <span class="t-validation-wrap l-fg1">
                  <input type="number" formControlName="PRN" class="t-field-text w100" />
                </span>
              </div>
            </div>

            <div class="w100" style="margin-bottom: 1em;" *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi'">
              <div class="l-flex l-flex-c t-field t-field-pad input">
                <label matTooltip="קוד טיפול">
                  קוד טיפול
                </label>
                <i class="t-sep"></i>
                <span class="t-validation-wrap l-fg1">
                  <select  class="t-field-text w100" formControlName="HMOExamName" (change)="setExamName($event)">
                    <option value=""></option>
                    <option *ngFor="let code of ls.maccabiExams" [value]="code.exam_name">{{code.code}} {{code.exam_name}}</option>
                  </select>
                </span>
              </div>
            </div>

            <div class="w50" style="padding-right: 0.5em; padding-bottom: 1em;" *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi' || gastroService.awlForm.get('HMO').value == 'Clalit'">
              <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="רשיון רופא/זיהוי מזמין">
                <label *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit'">
                  רשיון רופא/זיהוי מזמין
                </label>
                <label *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi'">
                  מס. רופא מפנה
                </label>
                <i class="t-sep"></i>
                <span class="t-validation-wrap l-fg1">
                  <input type="number" formControlName="Code" class="t-field-text w100" />
                  <div class="t-validation-message">
                    <span>Invalid Doctor ID</span>
                  </div>
                </span>
              </div>
            </div>
            <div class="w50" style="padding-left: 0.5em; padding-bottom: 1em;" *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi' || gastroService.awlForm.get('HMO').value == 'Clalit'">
              <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="שם פרטי המזמין">
                <label *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi'">
                  שם רופא מפנה
                </label>
                <label *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit'">
                  שם פרטי רופא מזמין
                </label>
                <i class="t-sep"></i>
                <span class="t-validation-wrap l-fg1">
                  <input type="text" formControlName="refDocName" class="t-field-text w100" />
                  <div class="t-validation-message">
                    <span>Invalid Doctor ID</span>
                  </div>
                </span>
              </div>
            </div>
            <div class="w50" style="padding-right: 0.5em; padding-bottom: 1em;" *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit'">
              <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="שם משפחה המזמין">
                <label>
                  שם משפחה רופא מזמין
                </label>
                <i class="t-sep"></i>
                <span class="t-validation-wrap l-fg1">
                  <input type="text" formControlName="refDocLastName" class="t-field-text w100" />
                  <div class="t-validation-message">
                    <span>Invalid Doctor ID</span>
                  </div>
                </span>
              </div>
            </div>
            <div class="w50" style="padding-left: 0.5em; padding-bottom: 1em;" *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit'">
              <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="קוד מרפאה">
                <label>
                  קוד מרפאה
                </label>
                <i class="t-sep"></i>
                <span class="t-validation-wrap l-fg1">
                  <input type="number" formControlName="BranchProviderID" class="t-field-text w100" />
                  <div class="t-validation-message">
                    <span>Invalid Doctor ID</span>
                  </div>
                </span>
              </div>
            </div>
            <div class="w50" style="padding-right: 0.5em; padding-bottom: 1em;" *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit'">
              <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="גורם שולח">
                <label>
                  גורם שולח
                </label>
                <i class="t-sep"></i>
                <span class="t-validation-wrap l-fg1">
                  <input type="text" formControlName="BranchProviderName" class="t-field-text w100" />
                  <div class="t-validation-message">
                    <span>Invalid Doctor ID</span>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>

    <!-- ======= Referring Doctor (Start) ======= -->
    <div class="w50" *ngIf="!hideRefDocAndResults">
      <section class="m-box" (dblclick)="gastroService.gastroForm.get('ReffDoc').setValue('')">
        <h2>Referring Doctor</h2>
        <div class="picker-row">
          <div class="picker-add">
            <input
              class="t-field"
              placeholder="Add referring doctor"
              [(ngModel)]="newRefDoc"
              [ngModelOptions]="{standalone: true}"
              [disabled]="loadingRefDocs || es.isClosed"
            />
            <button class="blue-btn picker-add-btn" [disabled]="loadingRefDocs || es.isClosed" (click)="addRefDoc()">+</button>
          </div>
          @if (loadingRefDocs) {
            <div class="picker-select-skeleton"></div>
          } @else {
            <mat-form-field class="picker-select">
              <mat-label>Referring Doctor</mat-label>
              <mat-select [formControl]="gastroService.gastroForm.get('ReffDoc')">
                <mat-select-trigger>{{gastroService.gastroForm.get('ReffDoc').value}}</mat-select-trigger>
                @for (doc of refDocList; track doc) {
                  <mat-option [value]="doc">
                    <span class="picker-option">
                      <span>{{doc}}</span>
                      <button
                        mat-icon-button
                        class="picker-option-remove"
                        aria-label="Remove referring doctor"
                        (click)="$event.stopPropagation(); deleteRefDoc(doc)"
                      >
                        ✕
                      </button>
                    </span>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </section>
      <!-- ======= Referring Doctor (End) ======= -->
      <section class="m-box">
        <h2>Procedure Results</h2>
        <div class="l-flex-c l-flex-w indicative-fieldset h100">
          <label class="t-label-top">
            <input type="radio" formControlName="ProcedureResult" value="No Clinical Findings" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>No Clinical Findings</span>
          </label>
          <label class="t-label-top">
            <input type="radio" formControlName="ProcedureResult" value="Clinical Findings" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>Clinical Findings</span>
          </label>
          <label class="t-label-top">
            <input type="radio" formControlName="ProcedureResult" value="Urgent Clinical Findings" class="custom-check -sq" />
            <i class="customInput-display -sq"></i>
            <span>Urgent Clinical Findings</span>
          </label>
        </div>
      </section>
    </div>

  </div>
    <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">

        <!-- =============== Recommendations (Start) =============== -->
        <div class="w100 summary-recommendations-col">
            <section class="m-box fulltext summary-recommendations-box">
                <h2>Recommendations</h2>
                <textarea formControlName="Recomm" class="scroller scroller-intro fulltext summary-recommendations-text"></textarea>
                <button class="t-btn-edit" *ngIf="!es.isClosed"
                    (click)="atS.showAuto(gastroService.gastroForm.get('Recomm'),'Recommendations',713)">Auto Text</button>
            </section>
        </div>
        <!-- =============== Recommendations (End) =============== -->
    </div>

    <!-- =============== Pathology Report (Start) =============== -->
    <div class="w100 l-flex-w t-boxMargin--spacebyPadding summary" style="justify-content: center;">
        <div class="w50">
            <section class="m-box">
                <h2>Pathology Report</h2>
                <div class="l-flex-c l-flex-w indicative-fieldset">
                    <button type="button" class="save_patieont" (click)="printPathologyForm()">
                        Print Pathology Report
                    </button>
                    <span *ngIf="pathologyError" style="color:#c0392b; margin: 0 1em;">
                        {{!gastroService.gastroForm.get('Reasone').value ? 'Exam Indication cannot be empty' : 'No samples have been taken for this exam'}}
                    </span>
                </div>
            </section>
        </div>
    </div>
    <!-- =============== Pathology Report (End) =============== -->

    <!-- =============== Exam Signature (Start) =============== -->
    <div class="w100 l-flex-w t-boxMargin--spacebyPadding summary" style="justify-content: center;" *ngIf="!hideSignature">
        <div class="w50 sign-exam-col">
            <section class="m-box">
                <h2>Sign Exam</h2>
                <div class="l-flex-c l-flex-w indicative-fieldset">
                    <button class="save_patieont"
                        *ngIf="ls.userType === 'doctor' && !showPrintOpts && !signatureService.isExamSigned(es.examObject)"
                        (click)="showPrintOpts = true">
                        Sign Exam as {{ls.getUserName()}}
                    </button>
                    <span *ngIf="signatureService.isExamSigned(es.examObject)">
                        Signed on {{es.examObject.SignedDate | date:'d-M-y H:mm:ss'}} by {{es.examObject.SignedBy}}
                    </span>
                </div>
            </section>
        </div>
    </div>
    <!-- =============== Exam Signature (End) =============== -->
</div>
</div>

<app-printopts *ngIf="showPrintOpts" (closed)="closePreview($event)" [showopts]="false" [signature]="true"></app-printopts>
</ng-template>